import { render, staticRenderFns } from "./OfferRequests.vue?vue&type=template&id=edbabede&scoped=true"
import script from "./OfferRequests.vue?vue&type=script&lang=ts"
export * from "./OfferRequests.vue?vue&type=script&lang=ts"
import style0 from "./OfferRequests.vue?vue&type=style&index=0&id=edbabede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbabede",
  null
  
)

export default component.exports